import React from 'react';
import { Grid, TextField } from '@material-ui/core';

const FirstName = ({ values, errors, touched, handleChange, handleBlur, disabled }) => {
  return (
    <Grid item xs={12} md={6}>
      <TextField
        label='First Name'
        name='Signer_First'
        variant='outlined'
        size='small'
        fullWidth
        value={values.Signer_First}
        onChange={ e => { 
          e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.substr(1).toLowerCase();
          handleChange(e)}}
        onBlur={handleBlur}
        helperText={touched.Signer_First && errors.Signer_First}
        error={Boolean(touched.Signer_First && errors.Signer_First)}
        disabled={disabled}
      />
    </Grid>
  );
}

export { FirstName };
